<template>
  <block style="padding-bottom: 60px;">
    <template slot="header"
      >Alerta Manual</template
    >

    <div class="alert-type">
      <h4 class="is-uppercase">Tipo de Alerta</h4>

      <div class="risk-factors">
        <div v-for="r in riskFactors" v-bind:key="r.code" class="risk-factors-item">
          <label>
            <input type="checkbox" class="risk-factor-check" v-model="r.on" />
            <span class="risk-factor-name is-lowercase">{{ r.name }}</span>
          </label>
        </div>
      </div>
    </div>

    <div class="alert-details">
      <h4 class="is-uppercase">DETALLES</h4>
      <textarea
        v-model="details"
        placeholder="Por favor especificar problema del estudiante"
      ></textarea>
    </div>

    <div class="responsible">
      <h4 class="is-uppercase">Remitir alerta a</h4>
      <div class="multiselect-container">
        <multiselect
          :options-list="possibleResponsibleUsersForAlert"
          v-model="selectedResponsible"
        ></multiselect>
      </div>
      <input
        v-model="messageForResponsible"
        class="responsible-message"
        type="text"
        max="140"
        style="margin-top: 10px"
        placeholder="Comentario personal para responsable de tarea (máx. 140 caracteres)."
      />
    </div>

    <div class="actions">
      <button
        class="button is-primary add"
        :class="{ 'is-loading': loading }"
        :disabled="!isValid"
        @click="submit"
      >
        Remitir
      </button>
      <button class="button is-primary is-outlined cancel" :disabled="loading" @click="cancel">
        Cancelar
      </button>
    </div>
  </block>
</template>

<script>
import gql from "graphql-tag"
import PROFILE_DETAIL from "../home/graphql/Profile.gql"
import LIST_ALERT from "../alerts/graphql/ListAlert.gql"
import Block from "@/components/_base/Block.vue"
import Multiselect from "@/components/shared/multiselect/Multiselect.vue"
import DerivationList from "@/components/_base/DerivationList.vue"
import OverlayedMixin from "@/mixins/OverlayedMixin"

export default {
  name: "ProfileRaiseAlert",
  mixins: [OverlayedMixin],
  props: {
    user: {
      type: Object
    },
    studentId: {
      type: String
    }
  },
  data() {
    return {
      loading: false,
      details: "",
      riskFactors: [
        {
          code: "ACADEMIC",
          name: "Académico",
          on: false
        },
        {
          code: "VOCATIONAL",
          name: "Vocacional",
          on: false
        },
        {
          code: "ECONOMIC",
          name: "Económico",
          on: false
        },
        {
          code: "INSTITUTIONAL",
          name: "Institucional",
          on: false
        },
        {
          code: "PERSONAL",
          name: "Personal",
          on: false
        },
        {
          code: "OTHER",
          name: "Otros",
          on: false
        }
      ],
      possibleResponsibleUsersForAlert: [],
      selectedResponsible: null,
      messageForResponsible: null,
      derivations: [],
      studentProfile: {
        student: {
          responsible: {}
        }
      }
    }
  },
  apollo: {
    possibleResponsibleUsersForAlert: {
      query: gql`
        query PossibleUsers($conditions: AlertMatrixConditions!) {
          possibleResponsibleUsersForAlert(conditions: $conditions) {
            id
            name
            email
          }
        }
      `,
      variables() {
        return {
          conditions: {
            riskFactors: this.riskFactorCodes
          }
        }
      },
      result() {
        // On result, clear the selected user
        this.selectedResponsible = null
      }
    },
    studentProfile: {
      query: gql`
        query StudentProfile($studentId: ID!) {
          studentProfile(studentId: $studentId) {
            student {
              id
              responsible {
                id
                name
              }
            }
          }
        }
      `,
      variables() {
        return {
          studentId: this.studentId
        }
      }
    }
  },
  computed: {
    isValid() {
      // Has selected a responsible for the alert
      if (this.selectedResponsible === -1 || this.selectedResponsible === null) {
        return false
      }

      // Has selected at least a risk factor
      var n_on = 0
      this.riskFactors.forEach(r => {
        if (r.on) {
          n_on++
        }
      })
      if (n_on == 0) {
        return false
      }

      // User must write some details about the alert
      if (this.details.length == 0) {
        return false
      }

      return true
    },
    riskFactorCodes() {
      return this.riskFactors.filter(r => r.on).map(r => r.code)
    },
    validDerivations() {
      const derivations = this.derivations.map(d => {
        return {
          userId: d.chosenUser && d.chosenUser.id ? d.chosenUser.id : null,
          message: d.message || null
        }
      })
      // Filter the ones without a user
      const validDerivations = derivations.filter(d => d.userId != null)
      return validDerivations
    },
    responsibleName() {
      const responsible = this.studentProfile.student.responsible || {}
      return responsible.name || "-"
    }
  },
  methods: {
    navigateTo(route) {
      console.log(`Navigating to...${route}`)
      this.$emit("hello", route)
    },
    submit() {
      // RAISE ALERT
      // Call the graphql mutation
      this.loading = true
      this.$apollo
        .mutate({
          // Query
          mutation: gql`
            mutation RaiseAlert($input: AlertInput!) {
              createAlert(input: $input) {
                id
                riskFactors
                isManual
                comment
              }
            }
          `,
          // Parameters
          variables: {
            input: {
              studentId: this.studentId,
              responsibleId: this.selectedResponsible.id,
              responsibleMessage: this.messageForResponsible,
              riskFactors: this.riskFactorCodes,
              isManual: true,
              comment: this.details,
              derivations: this.validDerivations
            }
          },
          refetchQueries: [
            { query: PROFILE_DETAIL, variables: { studentId: this.studentId } },
            { query: LIST_ALERT, variables: { studentId: this.studentId } }
          ]
        })
        .then(data => {
          // Result
          this.loading = false
          this.navigateTo("app.profile.alert_raised")
        })
        .catch(error => {
          this.loading = false
          console.error(error)
        })
    },
    cancel() {
      this.navigateTo("app.profile.alerts")
    },

    addDerivation() {
      const nextIndex = this.currentDerivationIndex + 1
      this.derivations.push({
        index: nextIndex,
        chosenUser: null
      })
      this.currentDerivationIndex = this.currentDerivationIndex++
    },
    removeDerivation(derivationIndex) {
      this.derivations.splice(derivationIndex, 1)
    }
  },
  components: {
    Block,
    DerivationList,
    Multiselect
  }
}
</script>

<style scoped>
.alert-type,
.alert-details,
.responsible {
  margin-bottom: 35px;
}

h4 {
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid #e0e0e0;
}

select {
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  height: 35px;
  width: 300px;
  background-color: #f2f2f2;
  color: #7a7a7a;
}

textarea {
  box-sizing: border-box;
  resize: vertical !important;
  display: block;
  width: 100%;
  min-height: 66px;
  background-color: #f2f2f2;
  border-color: #e0e0e0;
  border-radius: 5px;
  padding: 10px 10px;
}

.responsible-message {
  display: block;
  box-sizing: border-box;
  width: 100%;
  background-color: #f2f2f2;
  border-radius: 5px;
  border: 1px solid #e0e0e0;
  padding-left: 10px;
  height: 35px;
}

/* copypasted from new attention, refactor later ...later some day? */
.derivation {
  margin: 10px 0;
}

.derivation .button {
  height: 35px;
  width: 37px;
}

.derivation textarea {
  margin-top: 10px;
}

.add-derivation {
  margin-top: 10px;
  border-width: 2px;
}

.actions .add {
  padding: 0px 35px;
}
.actions .cancel {
  padding: 0 15px;
}
/* end of copy paste */

/* FACTORES DE RIESGO */
.risk-factors {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 10px;
}

.risk-factors label {
  cursor: pointer;
}

.risk-factors-item {
  flex-basis: 50%;
  margin: 3px 0;
}

.risk-factor-indicator {
  display: inline-block;
  margin-right: 5px;
  width: 8px;
  height: 8px;
  background: grey;
  border-radius: 25%;
}

.risk-factor-indicator.is-at-risk {
  background: #e33932;
}
.multiselect-container {
  max-width: 500px;
}
</style>
